(() => {
  document.querySelectorAll('[data-decor-examples]').forEach(gallery => {
    if (gallery.dataset.examplesReady) return;
    gallery.dataset.examplesReady = 'true';
    const rail = gallery.querySelector('[data-example-rail]');
    const controls = gallery.querySelector('[data-example-controls]');
    const previous = gallery.querySelector('[data-example-prev]');
    const next = gallery.querySelector('[data-example-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => {
      controls.hidden = rail.scrollWidth <= rail.clientWidth + 2;
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    };
    const step = direction => {
      const card = rail.querySelector('article');
      const gap = parseFloat(getComputedStyle(rail).gap) || 0;
      rail.scrollBy({left:direction * (card.getBoundingClientRect().width + gap),behavior:reducedMotion.matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    rail.addEventListener('scroll',update,{passive:true});
    rail.addEventListener('keydown',event => {
      if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();step(event.key === 'ArrowLeft' ? -1 : 1);
    });
    const root = gallery.closest('[data-decor]');
    const dialog = root.querySelector('[data-lightbox]');
    gallery.querySelectorAll('[data-example-enlarge]').forEach(button => button.addEventListener('click',() => {
      const image = button.querySelector('img');
      dialog.querySelector('[data-lightbox-image]').src = image.src;
      dialog.querySelector('[data-lightbox-image]').alt = image.alt;
      dialog.querySelector('[data-lightbox-caption]').textContent = image.alt;
      dialog.showModal();
    }));
    new ResizeObserver(update).observe(rail);
    update();
  });
})();
